import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09f3a6dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "delivery-zones-info" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "delivery-zones-info__title" }, " Бесплатная доставка при заказе на сумму: ", -1))
const _hoisted_3 = { class: "delivery-zones-info__list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "item__main" }
const _hoisted_6 = { class: "item__price rouble-symbol" }
const _hoisted_7 = {
  key: 0,
  class: "item__times-logo"
}
const _hoisted_8 = {
  key: 1,
  class: "item__times"
}
const _hoisted_9 = { class: "item__additional additional" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "additional__left-col" }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "additional__right-col rouble-symbol"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zones, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          ref_for: true,
          ref: `zone-${item.id}`,
          class: _normalizeClass(['item', { 'item--selected': item.id === _ctx.selectedId }, 'delivery-zones-info__item']),
          onClick: ($event: any) => (_ctx.$emit('select', item.id))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass([
              'item__color-wrapper',
              { 'item__color-wrapper--selected': item.id === _ctx.selectedId },
            ])
            }, [
              _createElementVNode("div", {
                class: "item__color",
                style: _normalizeStyle({
                backgroundColor: item.color,
                opacity:
                  item.id === _ctx.selectedId
                    ? _ctx.DELIVERY_ZONE_OPACITY.selected
                    : _ctx.DELIVERY_ZONE_OPACITY.unselected,
              })
              }, null, 4)
            ], 2),
            _createElementVNode("div", _hoisted_6, " От " + _toDisplayString(_ctx.$filters.formattedNumber(item.minOrderPrice)), 1),
            (item.deliveryTimeMin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7))
              : _createCommentVNode("", true),
            (item.deliveryTimeMin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item.deliveryTimeMin === item.deliveryTimeMax
                ? item.deliveryTimeMin
                : `${item.deliveryTimeMin}-${item.deliveryTimeMax}`) + " мин. ", 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            (item.deliveryPrice)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Зона с платной доставкой - " + _toDisplayString(item.deliveryPrice), 1))
              : _createCommentVNode("", true)
          ])
        ], 10, _hoisted_4))
      }), 128))
    ])
  ]))
}